var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2477",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.313,
    height: 48.215,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "idea_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1777",
    stroke: "#fff",
    strokeWidth: 0.75,
    d: "M0 0h48.313v48.215H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2156"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2094"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2096",
    clipPath: "url(#idea_svg__a)",
    stroke: "#fff",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2568",
    d: "M25.383 0c.895.155 1.8.279 2.683.469A16.9 16.9 0 0137.96 26.8c-.583.835-1.282 1.59-1.869 2.422a10.829 10.829 0 00-2.031 6.536q.015 1.153 0 2.307a4.247 4.247 0 01-2.639 4.094.828.828 0 00-.371.519 7.064 7.064 0 01-13.794 0 .881.881 0 00-.41-.54 4.211 4.211 0 01-2.586-3.883 28.65 28.65 0 010-2.213 11.382 11.382 0 00-2.93-8.018 16.755 16.755 0 01-4.148-11.55 16.955 16.955 0 0110.21-15.1 17.316 17.316 0 015.232-1.3A2.042 2.042 0 0022.929 0zm5.883 33.975c.173-.765.312-1.5.509-2.228a16.328 16.328 0 013.355-5.93 13.666 13.666 0 002.984-11.1 13.544 13.544 0 00-3.988-7.774A13.637 13.637 0 0025.137 2.9 13.516 13.516 0 0012.16 9.454 13.923 13.923 0 0013.48 26.2a14.079 14.079 0 012.708 4.485c.367 1.059.606 2.163.914 3.288zm-14.187 2.863v1.218a1.443 1.443 0 001.611 1.592h10.981a1.375 1.375 0 001.514-1.127 12.319 12.319 0 00.015-1.682zM28.1 42.495h-7.883a4.13 4.13 0 007.883 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2569",
    d: "M0 17.988a1.744 1.744 0 011.9-1.046c.75.05 1.506 0 2.259.012a1.413 1.413 0 110 2.821c-.753.01-1.509-.035-2.259.012A1.75 1.75 0 010 18.741z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2570",
    d: "M48.313 18.741a1.75 1.75 0 01-1.9 1.046c-.75-.047-1.506 0-2.259-.012a1.413 1.413 0 110-2.821c.753-.008 1.509.038 2.259-.012a1.744 1.744 0 011.9 1.046z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2571",
    d: "M5.251 10.732a1.461 1.461 0 01-.79 1.405A1.249 1.249 0 013 12.005 34.564 34.564 0 01.7 9.711a1.341 1.341 0 01.142-1.837 1.355 1.355 0 011.845-.079 38.73 38.73 0 012.228 2.23 2.164 2.164 0 01.327.706"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2572",
    d: "M47.907 9.074a3.313 3.313 0 01-.448.816c-.623.684-1.29 1.33-1.96 1.968a1.408 1.408 0 11-2-1.981 66.17 66.17 0 012-2 1.34 1.34 0 011.568-.268 1.485 1.485 0 01.838 1.459"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2573",
    d: "M3.704 24.424a1.456 1.456 0 011.365.753 1.228 1.228 0 01-.1 1.46 32.713 32.713 0 01-2.365 2.354 1.332 1.332 0 01-1.766-.149 1.312 1.312 0 01-.176-1.758c.748-.842 1.567-1.624 2.389-2.4a1.707 1.707 0 01.65-.262"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2574",
    d: "M47.902 27.692a1.459 1.459 0 01-.795 1.4 1.252 1.252 0 01-1.46-.141 34.976 34.976 0 01-2.265-2.259 1.391 1.391 0 011.972-1.941c.774.71 1.512 1.462 2.226 2.232a2.127 2.127 0 01.322.706"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2575",
    d: "M35.469 16.593v.017c.04 1.037-.48 1.713-1.346 1.751s-1.442-.6-1.481-1.632a8.449 8.449 0 00-8.295-8.232 1.47 1.47 0 01-1.526-1.89 1.4 1.4 0 011.375-.949 11.184 11.184 0 019.493 5.232 10.97 10.97 0 011.78 5.7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.5a5ed123878c925bddbbbe7fb896c6dc.svg";
export { ForwardRef as ReactComponent };